import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer_container containerAll">
        <div className="content_icons">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/@CantiRondas"
            className="ga4-call_to_action-redes_footer"
          >
            <div className="youtube">
              <img loading="lazy" src="/assets/social_media/youtube.png" alt="" />
            </div>
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/canti.rondas/"
            className="ga4-call_to_action-redes_footer"
          >
            <div className="instagram">
              <img loading="lazy" src="/assets/social_media/instagram.png" alt="" />
            </div>
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/cantirondas"
            className="ga4-call_to_action-redes_footer"
          >
            <div className="facebook">
              <img loading="lazy" src="/assets/social_media/facebook.png" alt="" />
            </div>
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://open.spotify.com/artist/1oaOuEY1r5gNPPq1G9Y9eC?si=FTNP8YzSSlaYhhULcvqjnw"
            className="ga4-call_to_action-redes_footer"
          >
            <div className="spotify">
              <img loading="lazy" src="/assets/social_media/spotify.png" alt="" />
            </div>
          </a>

          <a
            target="_blank"
            href="https://vm.tiktok.com/ZM2vXdeaQ/"
            className="ga4-call_to_action-redes_footer"
          >
            <div className="tick">
              <img src="/assets/social_media/t.png" alt="t" />
            </div>
          </a>
        </div>

        <div className="content_policy">
          <a href="/assets/AvisoPrivacidadFm.pdf" download>
            Políticas de privacidad
          </a>
        </div>

        <div className="content_rights">
          <p>© 2023 FM Entretenimiento </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
